import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { deleteManagerBoard, getManagerBoard } from '../../../api/managerBoardApi';
import FileAttachment from '../../../components/FileAttachment/FileAttachment';

function BoardView() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const currentPage = searchParams.get('page') || 1;
  const search = searchParams.get('search') || '';

  const [loading, setLoading] = useState(true);
  const [post, setPost] = useState(null);
  const attachFiles = Array.isArray(post?.files)
    ? post.files.filter((file) => ['attach', 'attatch'].includes(String(file?.file_type || '').toLowerCase()))
    : [];

  const formatDateTime = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const ampm = hours < 12 ? '오전' : '오후';
    const hour12 = hours % 12 || 12;
    return `${year}-${month}-${day} ${ampm} ${hour12}:${minutes}:${seconds}`;
  };

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getManagerBoard(id);
      setPost(data || null);
    } catch (err) {
      console.error('관리자 게시글 조회 실패:', err);
      alert('관리자 게시글 조회 실패');
      navigate('/manager/board');
    } finally {
      setLoading(false);
    }
  }, [id, navigate]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const handleDelete = async () => {
    if (!window.confirm('게시글을 삭제하시겠습니까?')) return;
    try {
      await deleteManagerBoard(id);
      navigate(`/manager/board?page=${currentPage}&search=${encodeURIComponent(search)}`);
    } catch (err) {
      console.error('관리자 게시글 삭제 실패:', err);
      alert('관리자 게시글 삭제 실패');
    }
  };

  if (loading) {
    return (
      <div className="text-center text-muted mt-5">
        <div className="spinner-border text-secondary mb-3" role="status" />
        <p>불러오는 중...</p>
      </div>
    );
  }

  if (!post) return <div className="text-center text-muted mt-5">게시글 데이터가 없습니다.</div>;

  return (
    <div className="container-fluid view-post">
      <div className="row">
        <div className="col-12">
          <div className="post-header-fixed expanded">
            <div>
              <small className="text-muted d-block mb-1">관리자 게시판</small>
              <h4 className="mb-0 text-dark">{post.title}</h4>
            </div>

            <div className="d-flex gap-2" style={{ position: 'relative' }}>
              <button
                className="btn btn-outline-primary btn-sm"
                onClick={() => navigate(`/manager/board?page=${currentPage}&search=${encodeURIComponent(search)}`)}
              >
                목록
              </button>
              <button
                className="btn btn-outline-info btn-sm"
                onClick={() => navigate(`/manager/board/${id}/edit?page=${currentPage}&search=${encodeURIComponent(search)}`)}
              >
                수정
              </button>
              <button className="btn btn-outline-danger btn-sm" onClick={handleDelete}>
                삭제
              </button>
            </div>
          </div>

          <div className="d-flex justify-content-between text-muted mb-3 mt-3 pt-2">
            <small>작성자: {post.writer_id || '-'}</small>
            <small>{formatDateTime(post.created_at)}</small>
          </div>

          <div className="post-body mb-4">
            <div
              className="post-content"
              dangerouslySetInnerHTML={{ __html: post.content || '' }}
            />
          </div>

          {attachFiles.length > 0 && (
            <div className="mb-4">
              <h6 className="fw-bold mb-2">첨부파일</h6>
              <FileAttachment files={attachFiles} mode="view" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default BoardView;
